import React from 'react';
import {
    TextInput,
    FlexDiv,
    TextTiny,
    ThemedButton,
    palette,
} from '@awarego-ui/components';
import { CircularProgress } from '@mui/material';
import Popover from '@mui/material/Popover';

function AddToListModal({
    showAddToListModal,
    onClose,
    showNewListInput,
    setShowNewListInput,
    newListInput,
    setNewListInput,
    handleCreateNewList,
    savingList,
    lists,
    selectedListId,
    onSelectList,
    onAddToSelectedList,
    addingUsers,
}) {
    return (
        <Popover
            anchorEl={showAddToListModal}
            keepMounted
            open={Boolean(showAddToListModal)}
            onClose={onClose}
            disableScrollLock={true}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            PaperProps={{ style: { overflow: 'hidden' } }}
        >
            <FlexDiv
                column
                py={16}
                px={24}
                width={272}
                maxHeight={320}
                $noWrap
                overflowHidden
            >
                <FlexDiv
                    borderBottom={!showNewListInput}
                    pb={8}
                    style={{ flexShrink: 0 }}
                >
                    <TextTiny
                        bold
                        link
                        onClick={() => setShowNewListInput(true)}
                    >
                        Create new list
                    </TextTiny>
                </FlexDiv>
                {showNewListInput && (
                    <FlexDiv
                        column
                        alignEnd
                        pb={8}
                        borderBottom
                        gap={8}
                        style={{ flexShrink: 0 }}
                    >
                        <TextInput
                            value={newListInput}
                            onChange={(e) => setNewListInput(e.target.value)}
                            placeholder="Enter list name"
                            inline
                            stretched
                        />
                        <ThemedButton
                            mode="primary"
                            disabled={newListInput === '' || savingList}
                            size="small"
                            $noTextTransform
                            onClick={handleCreateNewList}
                            text={
                                savingList ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    'Create'
                                )
                            }
                        />
                    </FlexDiv>
                )}
                <FlexDiv
                    column
                    mt={8}
                    flexGrow={1}
                    $noWrap
                    style={{
                        minHeight: 0,
                        overflowY: 'auto',
                        overflowX: 'hidden',
                    }}
                >
                    {lists.map((list, i, arr) => {
                        const isSelected = selectedListId === list.id;
                        return (
                            <TextTiny
                                bold
                                key={list.id}
                                link={!isSelected}
                                mt={8}
                                mb={i !== arr.length - 1 && 8}
                                onClick={() => onSelectList(list.id)}
                                style={{
                                    padding: '4px 8px',
                                    borderRadius: 4,
                                    cursor: 'pointer',
                                    width: '100%',
                                    wordBreak: 'break-word',
                                    ...(isSelected
                                        ? {
                                              backgroundColor:
                                                  palette.evergreen.mintLight,
                                              color: palette.evergreen.aspargus,
                                          }
                                        : {}),
                                }}
                            >
                                {list.name}
                            </TextTiny>
                        );
                    })}
                </FlexDiv>
                <FlexDiv
                    mt={16}
                    pt={8}
                    width="100%"
                    borderTop
                    style={{ flexShrink: 0 }}
                >
                    <ThemedButton
                        mode="primary"
                        size="small"
                        $noTextTransform
                        style={{ width: '100%' }}
                        disabled={!selectedListId || addingUsers}
                        onClick={onAddToSelectedList}
                        text={
                            addingUsers ? (
                                <CircularProgress size={20} />
                            ) : (
                                'Add'
                            )
                        }
                    />
                </FlexDiv>
            </FlexDiv>
        </Popover>
    );
}

export default AddToListModal;
